import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { PUBLIC_ROOT } from "config/constants";
import Button from "components/library/Button";
import DropdownMenu from "components/library/DropdownMenu";
import IconButton from "components/library/IconButton";
import { VALIDATION_MESSAGE } from "config/constants/editor";
import {
  updateDeepDiveFormAt,
  validateDeepDiveFormAsync,
  saveDeepDiveForm,
} from "deepDiveEditor/actions/form";
import copy from "utils/clipboard";
import { setMessage } from "actions/message";

// NOTE: reusing styles from EditorCTA
import styles from "../../../editor/containers/EditorCTA/EditorCTA.css";

class DeepDiveEditorCTA extends Component {
  constructor(props) {
    super(props);

    this.copyHandler = this._copyHandler.bind(this);
    this.toggleMoreOptions = this._toggleMoreOptions.bind(this);
    this.validateAndRedirect = this._validateAndRedirect.bind(this);
    this.getBaseUrl = this._getBaseUrl.bind(this);
    this.getLink = this._getLink.bind(this);

    this.state = {
      moreOptionsVisible: false,
    };
  }

  _getBaseUrl() {
    if (this.props.form.id) return `/editor/deep-dive/${this.props.form.id}`;
  }

  _getLink() {
    const id = this.props.form.front_cover;
    const isPublished = !!this.props.form.published_date;
    if (!id || !isPublished) return;
    // TODO: get real url with front cover slug
    return `${PUBLIC_ROOT}/${this.props.form.slug}-${id}.html?deepDive=1`;
  }

  _toggleMoreOptions() {
    this.setState({ moreOptionsVisible: !this.state.moreOptionsVisible });
  }

  handleErrs() {
    return Promise.reject(new Error(VALIDATION_MESSAGE));
  }

  _copyHandler(e) {
    e.preventDefault();
    copy(this.getLink());
  }

  _validateAndRedirect(newPath) {
    return this.props
      .validateDeepDiveFormAsync(this.props.form)
      .catch(this.handleErrs)
      .then(() => this.props.saveDeepDiveForm(true))
      .then(() => this.props.history.push(`${this.getBaseUrl()}/${newPath}`))
      .catch(error => this.props.setMessage({ message: error }));
  }

  render() {
    const copy = (
      <div
        key="copy-link"
        data-testid="copy-link"
        role="button"
        onClick={this.copyHandler}
        className="gtm-copy-link"
      >
        Copy link
      </div>
    );
    const unpublish = (
      <Link
        key="unpublish"
        to={`${this.getBaseUrl()}/unpublish`}
        className={classNames(styles.warning, "gtm-unpublish")}
      >
        Unpublish
      </Link>
    );
    const deleteDraft = (
      <Link
        key="delete-draft"
        to={this.getBaseUrl() ? `${this.getBaseUrl()}/delete` : "/dashboard"}
        className={classNames(styles.warning, "gtm-delete-draft")}
      >
        Delete draft
      </Link>
    );
    const buttonStates = {
      draft: {
        primary: "Publish",
        primaryAction: () => this.validateAndRedirect("publish"),
        secondary: [deleteDraft],
      },
      published: {
        primary: "Update",
        primaryAction: () => this.validateAndRedirect("update"),
        secondary: [copy, unpublish],
      },
    };

    const buttons = this.props.form.published_date
      ? buttonStates.published
      : buttonStates.draft;

    return (
      <div className={styles.root}>
        <Button
          data-testid="primary"
          onClick={buttons.primaryAction}
          data-cy="ctaActionButton"
          type="primary"
        >
          {buttons.primary}
        </Button>
        <IconButton
          className="gtm-more-options"
          name="more-horizontal"
          onClick={this.toggleMoreOptions}
        />
        <div className={styles.positionDropdown}>
          <DropdownMenu
            className={styles.moreOptions}
            isVisible={this.state.moreOptionsVisible}
            onClose={this.toggleMoreOptions}
            closeOnFirstClick={true}
          >
            {buttons.secondary}
          </DropdownMenu>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  form: state.deepDiveEditor.form,
});

const mapDispatchToProps = {
  updateDeepDiveFormAt,
  saveDeepDiveForm,
  setMessage,
  validateDeepDiveFormAsync,
};

DeepDiveEditorCTA.propTypes = {
  form: PropTypes.object,
  updateDeepDiveFormAt: PropTypes.func,
  saveDeepDiveForm: PropTypes.func,
  validateDeepDiveFormAsync: PropTypes.func,
  setMessage: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeepDiveEditorCTA);
